// Pure bar-chart geometry for the Review tab's daily spend/PR-count charts
// (#1192) — no chart library (this repo has none), a plain div-height bar
// chart same in spirit as ProductOwnerActivityHeatmap.vue's own div-grid
// cells. Kept separate from the rendering component so the math is
// unit-testable without mounting anything, matching
// productOwnerActivityHeatmap.ts's own split.
export interface ReviewChartBar {
  date: string
  value: number
  // 0-100, relative to the series' own max — each chart scales to its own
  // data, since spend and PR count are different units on purpose (#1192's
  // "one axis per chart, never a dual-axis chart").
  heightPercent: number
}

export function buildReviewChartBars<T extends { date: string }>(
  days: T[],
  valueOf: (day: T) => number,
): ReviewChartBar[] {
  const values = days.map(valueOf)
  const max = Math.max(0, ...values)
  return days.map((day, i) => ({
    date: day.date,
    value: values[i],
    heightPercent: max === 0 ? 0 : (values[i] / max) * 100,
  }))
}
